/* eslint-disable react/prop-types */

import moment from "moment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

const getStatus = (status) => {
  switch (status.toLowerCase()) {
    case "a":
      return "Active";
    case "t":
      return "Terminated";
    case "l":
      return "On Leave";
    default:
      return "Pending";
  }
};

export default function tableConfig() {
  return {
    columns: [
      { Header: "Employee number", accessor: "code", align: "left" },
      { Header: "Name", accessor: "fullName", align: "left" },
      { Header: "Email", accessor: "email", align: "center" },
      { Header: "SSN", accessor: "ssn", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Company", accessor: "company", align: "center" },
      { Header: "Location", accessor: "location", align: "center" },
      { Header: "Job", accessor: "job", align: "center" },
      { Header: "Rate", accessor: "rate", align: "center" },
      { Header: "Created At", accessor: "createdAt", align: "center" },
      { Header: "Actions", accessor: "action", align: "center" },
    ],
    getRows: (data, locationData, jobData, companyData, setContractorToEdit) =>
      data.map((d) => ({
        code: d.code,
        fullName: `${d.firstName} ${d.lastName}`,
        email: d.email,
        ssn: d.ssn,
        status: getStatus(d.status),
        company: companyData[d.subCompany]?.name || "",
        location: locationData[d.location]?.name || "",
        job: jobData[d.job]?.name || "",
        rate: `$${d.rate || ""}`,
        createdAt: d.createdAt ? moment(d.createdAt).locale("en").format("LLL") : "Never",
        action: (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setContractorToEdit(d)}
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
        ),
      })),
  };
}
